<template>
    <div class="delete-confirmation">
        <v-card-title>
            <h2 v-if="type" class="dialog-card__header">Delete {{type}}</h2>
        </v-card-title>
        <v-form>
            <v-card-text v-if="name" class="dialog-card__message">
                <h3>Are you sure you want to delete <span class="name">{{name}}</span> {{type}}?</h3>
            </v-card-text>
            <v-card-text v-if="communityIsUsed" class="error-message">
                This community is in use. It can not be deleted!
            </v-card-text>
            <v-card-actions class="btn-container">
                <v-btn class="custom-btn custom-btn--see-through" color="secondary" @click="cancel">
                    Cancel
                </v-btn>
                <v-btn :disabled="communityIsUsed" class="custom-btn" color="secondary" @click="confirm">
                    Delete
                </v-btn>
            </v-card-actions>
        </v-form>
    </div>
</template>

<script>
    export default {
        name: "DeleteConfirmation",
        data: () => ({
            id: null,
            type: null,
            name: null,
            returnToCompName: null,
            communityIsUsed: false
        }),
        methods: {
            confirm() {
                this.$router.push({name: this.returnToCompName, params: {dialog: 'false', id: this.id}})
            },
            cancel() {
                return this.$router.push({name: this.returnToCompName, params: {dialog: 'false'}});
            },
        },
        mounted() {
            this.id = this.$route.params.id;
            this.type = this.$route.params.type;
            this.name = this.$route.params.name || this.$route.params.key.name;
            this.returnToCompName = this.$route.params.returnToCompName;
            this.communityIsUsed = this.$route.params.communityIsUsed;
        }
    }
</script>

<style scoped>

</style>
